import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import InputAdornment from '@mui/material/InputAdornment';

import OthelloToolTipIcon from "./OthelloTooltipIcon.jsx";

import MDInput from "../components/MDInput/index.js";
import MDBox from "../components/MDBox/index.js";
import Help from "@mui/icons-material/Help";

export default function OthelloEdit({ ...props }) {


    const {
        label,
        labelliteral,
        fieldname,
        currentvalue,
        readonly,
        color,
        icono,
        etiqueta,
        iconoposicion,
        etiquetaposicion,
        rows,
        type,
        disabled,
        autocompletado,
        focused,
        onhandlePress,
        initeditexterno,
        setiniteditexterno,
        maxlength,
        variant
    } = props;

    const { t } = useTranslation();

    const [onlinevalue, setonlinevalue] = useState(props.currentvalue);
    const [evento, setevento] = useState(false);

    React.useEffect(() => {

        if (initeditexterno != null && initeditexterno) {
            setiniteditexterno(false);
            setevento(false);
        }
    });

    const handleChange = (event) => {

        setonlinevalue(event.target.value);
        setevento(true);
    }

    const handleFocus = (event) => {
        if (props.onlostfocus != null)
            props.onlostfocus(props.fieldname, event.target.value);
    }

    const handleSelected = (event) => {
        event.target.select();
    }

    const handlePress = (e) => {

        if (e != null) {
            if (onhandlePress != null)
                onhandlePress(e.key);
            //if (e.key === 'Enter') {

            //}
        }
    }

    let sololectura = readonly != null && readonly;

    let decoraicono = icono != null && iconoposicion != null ? <InputAdornment position={iconoposicion}><props.icono /></InputAdornment> : "";
    let decoraetiqueta = etiqueta != null && etiquetaposicion != null ? <InputAdornment position={etiquetaposicion}>{etiqueta}</InputAdornment> : "";

    let decoracioninicio = "";

    if (iconoposicion == "start")
        decoracioninicio = decoraicono;
    else if (etiquetaposicion == "start")
        decoracioninicio = decoraetiqueta;

    let decoracionfin = "";

    if (iconoposicion == "end")
        decoracionfin = decoraicono;
    else if (etiquetaposicion == "end")
        decoracionfin = decoraetiqueta;

    let multilineafinal = rows != null && rows > 1;

    //Si el que ha provocado el cambio es el evento entonces el valor del input es el que viene del evento, pero sino, el valor sera el de por defecto    
    let valor = evento ? onlinevalue : currentvalue;

    //Limpiamos que el cambio ha sido por el evento, por si en otro lugar se ha realizado el deshacer, o al principio, que en esos casos debe tomar el de por defecto
    //if(evento)
    //    setevento(false);

    let doshrink = valor != null && (valor != "" || !isNaN(valor));
    let MaxChars = (maxlength == null || (maxlength != null && (maxlength == "" || isNaN(maxlength)))) ? -1 : parseInt(maxlength);

    return <MDBox p={1} ><MDInput variant={variant != null ? variant : "standard"} id={fieldname} name={fieldname} type={type} label={t != null && labelliteral != null ? t(labelliteral) : label} autoComplete={autocompletado != null && autocompletado ? "on" : "off"} fullWidth onChange={handleChange} onBlur={handleFocus}
        onKeyPress={onhandlePress != null ? handlePress : null}
        success={color != null && color == "success"} error={color != null && color == "error"} disabled={disabled} inputProps={{ maxLength: MaxChars, readOnly: sololectura, startAdornment: decoracioninicio, endAdornment: decoracionfin }} rows={rows} multiline={multilineafinal} size="small"
        value={valor != null ? valor : ""} onFocus={focused != null && focused ? handleSelected : null} autoFocus={focused != null && focused} /></MDBox>

    //labelProps={{ shrink: true }}
    {/*  <OthelloToolTipIcon texto="Acceda a sus " icono={Help} />*/ }
}


OthelloEdit.propTypes = {
    variant: PropTypes.object,    
    items: PropTypes.object.isRequired,
    labelliteral: PropTypes.string,
    label: PropTypes.string,
    fieldname: PropTypes.string,
    currentvalue: PropTypes.object,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool, //OJO- EL PONER DISABLED LO QUITA DE LOS RESULTADOS DEVUELTOS DEL FORM
    color: PropTypes.oneOf([
        "success",
        "error"
    ]),
    icono: PropTypes.object,
    iconoposicion: PropTypes.oneOf([
        "start",
        "end"
    ]),
    etiqueta: PropTypes.object,
    etiquetaposicion: PropTypes.oneOf([
        "start",
        "end"
    ]),
    type: PropTypes.string,
    rows: PropTypes.number,
    onlostfocus: PropTypes.object,
    autocompletado: PropTypes.bool,
    focused: PropTypes.bool,
    onhandlePress: PropTypes.object,
    initeditexterno: PropTypes.object,
    maxlength: PropTypes.number,
    setiniteditexterno: PropTypes.object// Un estate externo para gestionar la inicializacion del edit -->>> const [evento, setevento] = useState(false);
};
